import { colors } from '../data/colors';
import infoScreenContent from '../data/TooltipContent.json';

interface Foundation {
  title: string;
  description: string;
  class: string;
  color: string;
}

const colorMap: { [key: string]: string } = {
  'Care/Harm': colors.careHarm,
  'Fairness/Cheating': colors.fairnessCheating,
  'Loyalty/Betrayal': colors.loyaltyBetrayal,
  'Authority/Subversion': colors.authoritySubversion,
  'Sanctity/Degradation': colors.sanctityDegradation,
  'Liberty/Oppression': colors.libertyOppression
};

export const getTagExplanation = (tag: string): { description: string; color: string } => {
  const foundations: Foundation[] = infoScreenContent.foundations;
  const foundation = foundations.find(f => f.title.toLowerCase() === tag.toLowerCase());
  const color = colorMap[tag] || '#FFFFFF';

  return foundation 
    ? { description: foundation.description, color: color }
    : { description: 'No explanation available', color: color };
};